import React, { useState, useEffect} from 'react'
import { Calendar, momentLocalizer, Views } from 'react-big-calendar'
import LoadingSpinner from '../../components/LoadingSpinner'
import 'react-big-calendar/lib/css/react-big-calendar.css'
import './styles.css'
import moment from 'moment-timezone'

// Set default timezone
moment.tz.setDefault('America/New_York')

const localizer = momentLocalizer(moment)

const UpdateCalendar = ({ appointment, spots, setSelectedEvent, selectedEvent }) => {
  const {appointment_id} = appointment
  const [calendarEvents, setCalendarEvents] = useState([])
  const [customEvents, setCustomEvents] = useState([])
  const [recurringEvents, setRecurringEvents] = useState({ sunday: [], monday: [], tuesday: [], wednesday: [], thursday: [], friday: [], saturday: [] })
  const [loading, setLoading] = useState(false)

  const populateCalendar = async (date, view) => {
    const referenceDay = moment(date).format()
    const recurringEventArray = []
    const customEventArray = []
    const weekStart = moment(date).startOf('week').subtract(1, 'days').format('YYYY-MM-DD')
    const weekEnd = moment(date).endOf('week').add(1,'days').format('YYYY-MM-DD')

    const getBookedResponse = await fetch(`${process.env.REACT_APP_SERVER}/booked/${appointment_id}?start=${weekStart}&end=${weekEnd}`)
    const getBookedResponseJSON = await getBookedResponse.json()

    const bookedEvents = getBookedResponseJSON.data.bookedEvents

    Object.keys(recurringEvents).forEach(async (day, index) => {
      const currentDay = moment(referenceDay).format('d')
      const dayDiff = index - currentDay
      const formattedDate = moment(referenceDay).add(dayDiff, 'd').format('YYYY-MM-DD')

      if (customEvents[formattedDate]) {
        customEvents[formattedDate].forEach((event, index) => {
          // console.log('EVEN', timeVariants.duration % (event.end - event.start) === 0)
          // if (useDuration && timeVariants.duration % (event.end - event.start) === 0) {
          //   console.log('SET INCREMENTS')
          // }
          const setStart = `${moment(date).add(dayDiff, 'd').format('YYYY-MM-DD')} ${moment(event.start_time).format('HH:mm:00')}`
          const setEnd = `${moment(date).add(dayDiff, 'd').format('YYYY-MM-DD')} ${moment(event.end_time).format('HH:mm:00')}`
          let spotsRemaining = spots
          let selectable = true

          bookedEvents[formattedDate] && bookedEvents[formattedDate].forEach(event => {
            if (moment(setStart).format('HH:mm:00') === moment(event.time).format('HH:mm:00')) {
              spotsRemaining = spotsRemaining - event.quantity
              if (spotsRemaining < 1) {
                selectable = false
              }
            }
          })

          customEventArray.push({ title: `Seats left: ${spotsRemaining > 0 ? spotsRemaining : 0}`, start: moment(setStart).toDate(), end: moment(setEnd).toDate(), resource: { recurring: null, spotsRemaining, selectable } })
        })
      }
      if (recurringEvents[day]) {
        recurringEvents[day].forEach((event, index) => {
          const setStart = `${moment(date).add(dayDiff, 'd').format('YYYY-MM-DD')} ${moment(event.start_time).format('HH:mm:00')}`
          const setEnd = `${moment(date).add(dayDiff, 'd').format('YYYY-MM-DD')} ${moment(event.end_time).format('HH:mm:00')}`
          let spotsRemaining = spots
          let selectable = true

          // If exclude dates includes formattedDate return without pushing to recurringEventArray
          if (event?.exclude_dates.includes(formattedDate)) return

          bookedEvents[formattedDate] && bookedEvents[formattedDate].forEach(event => {
            if (moment(setStart).format('HH:mm:00') === moment(event.time).format('HH:mm:00')) {
              spotsRemaining = spotsRemaining - event.quantity
              if (spotsRemaining < 1) {
                selectable = false
              }
            }
          })
          if (moment(setStart).isSameOrAfter(moment(event.start_time)) && (!moment(event?.recurs_until).isValid() || moment(setStart).isSameOrBefore(moment(event.recurs_until)))) {
            recurringEventArray.push({ title: `Seats left: ${spotsRemaining > 0 ? spotsRemaining : 0}`, start: moment(setStart).toDate(), end: moment(setEnd).toDate(), resource: { recurring: day, spotsRemaining, selectable } })
          }
        })
      }
    })

    setCalendarEvents(calEvents => {
      return [...recurringEventArray, ...customEventArray]
    })
  }

  useEffect(() => {
    (async function () {
      setLoading(true)
      const recurringEventsSorted = { sunday: [], monday: [], tuesday: [], wednesday: [], thursday: [], friday: [], saturday: [] }
      const customEventsSorted = {}

      try {
        const response = await fetch(`${process.env.REACT_APP_SERVER}/appointments/${appointment_id}`)
        if (response.status !== 200) {
          throw new Error('Could not get events.')
        }
        const responseJSON = await response.json()

        responseJSON.data.customEvents.forEach(event => {
          const date = moment(event.date).format('YYYY-MM-DD')
          // Do not add custom event to array if hidden
          if (event?.hidden === 1) return

          customEventsSorted[date] = customEventsSorted[date] && customEventsSorted[date].length ? [...customEventsSorted[date], event] : [event]
        })
        responseJSON.data.recurringEvents.forEach(event => {
          const excludeDates = event?.exclude_dates ? JSON.parse(event?.exclude_dates) : []
          recurringEventsSorted[event.day].push({...event, exclude_dates: excludeDates})
        })

        setCustomEvents(customEventsSorted)
        setRecurringEvents(recurringEventsSorted)

        setLoading(false)
      } catch (error) {
        console.log(error)
      }
    })()
  }, [appointment_id])

  // Set events onload
  useEffect(() => {
    // const {start_time: start, end_time: end } = appointment
    // handleSelectEvent({start, end})
    populateCalendar(moment(appointment.date).format())
  }, [customEvents, recurringEvents])

  const handleSelectEvent = (event) => {
    setSelectedEvent(event)
  }

  const formats = {
    selectRangeFormat: () => '8:00am | 2:00pm'
  }

  const handleEventPropGetter = ({ start, resource }) => {
    const eventStart = moment(start)
    const now = moment()

    if (moment(appointment.date).format("YYYY-MM-DD") === moment(start).format("YYYY-MM-DD") && moment(appointment.start_time).format("HH:mm") === moment(start).format("HH:mm")) {
      if (!selectedEvent) {
        handleSelectEvent(appointment)
      }
      return {
        style: { pointerEvents: 'none', background: '#fff', color: '#333', border: '3px solid #FD6A4F' }
      }
    }

    if ((resource && resource.selectable === false) || ((eventStart.diff(now) < 0) || !(resource.spotsRemaining >= appointment.quantity))) {
      if (moment(appointment.date).format("YYYY-MM-DD") === moment(start).format("YYYY-MM-DD") && moment(appointment.start_time).format("HH:mm") === moment(start).format("HH:mm")) {
        if (!selectedEvent) {
          handleSelectEvent(appointment)
        }
        return {
          style: { pointerEvents: 'none', background: '#fff', color: '#333', border: '3px solid #FD6A4F' }
        }
      }
      return {
        style: { pointerEvents: 'none', background: '#d1d1d1', color: '#999', borderColor: '#999' }
      }
    }
  }

  // const handleSelect = ({ start, end }) => {
  //   const title = window.prompt('New Event name')
  //   if (title) {
  //     populateCalendar(() => [...events, { start, end, title }])
  //   }
  // }

  const handleNavigate = (date, view) => {
    populateCalendar(date)
  }

  return (
    <>
      {!loading && (
      <div>
        <p style={{color: '#fd6a4f'}}>Note: All times are in EST</p>
        <Calendar
          selectable
          defaultDate={moment(appointment.date).format()}
          min={moment().set({'hours': 10, 'minutes': 0}).toDate()}
          max={moment().set({'hours': 20, 'minutes': 0}).toDate()}
          localizer={localizer}
          events={calendarEvents}
          views={['week']}
          formats={formats}
          defaultView={Views.WEEK}
          startAccessor="start"
          endAccessor="end"
          style={{}}
          drilldownView="week"
          onNavigate={handleNavigate}
          onSelectEvent={handleSelectEvent}
          eventPropGetter={handleEventPropGetter}
          // onSelectSlot={handleSelect}
        />
      </div>
      )}
      {loading && (<LoadingSpinner />)}
    </>
  )
}

export default UpdateCalendar
